import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const OnderhoudOverzicht = () => {
  const { terms } = useAuth();
  const { gebruiker } = useAuth();
  const [overzicht, setOverzicht] = useState([]);
  const [categorieen, setCategorieen] = useState([]);
  const [selectedCat, setSelectedCat] = useState('alle');
  const [loading, setLoading] = useState(true);
  const [gezondheid, setGezondheid] = useState(null);
  useEffect(() => {
    api.get('/onderhoud/gezondheid')
      .then(r => setGezondheid(r.data.gezondheid || null))
      .catch(() => setGezondheid(null));
  }, []);
  const [activeTab, setActiveTab] = useState('overzicht');
  const [bulkData, setBulkData] = useState([]);
  const [saving, setSaving] = useState(false);
  const [planningJaar, setPlanningJaar] = useState(new Date().getFullYear());
  const [bulkOrdnr, setBulkOrdnr] = useState('');

  const [selectedIds, setSelectedIds] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkStartDatum, setBulkStartDatum] = useState('');
  const [bulkPerWeek, setBulkPerWeek] = useState(10);
  const [bulkFreq, setBulkFreq] = useState('');
  const [bulkSorteerPostcode, setBulkSorteerPostcode] = useState(true);

  // Massa-aanmaak state
  const [showMassaModal, setShowMassaModal] = useState(false);
  const [alleCategorieen, setAlleCategorieen] = useState([]);
  const [onderhoudTypes, setOnderhoudTypes] = useState([]);
  const [checklistTemplates, setChecklistTemplates] = useState([]);
  const [massaCat, setMassaCat] = useState('');
  const [massaSubcat, setMassaSubcat] = useState('');
  const [massaKlanten, setMassaKlanten] = useState([]);
  const [massaGeselecteerd, setMassaGeselecteerd] = useState([]);
  const [massaZoek, setMassaZoek] = useState('');
  const [massaLoadingKlanten, setMassaLoadingKlanten] = useState(false);
  const [massaAlleenZonder, setMassaAlleenZonder] = useState(true);
  const [massaType, setMassaType] = useState('');
  const [massaFreq, setMassaFreq] = useState('jaarlijks');
  const [massaAantal, setMassaAantal] = useState(1);
  const [massaEenheid, setMassaEenheid] = useState('jaar');
  const [massaInhuurTemplates, setMassaInhuurTemplates] = useState([]);
  const [inhuurResources, setInhuurResources] = useState([]);
  useEffect(() => {
    api.get('/inhuur/resources').then(r => {
      const list = r.data.resources || r.data || [];
      setInhuurResources(Array.isArray(list) ? list.filter(x => x.actief !== false) : []);
    }).catch(() => {});
  }, []);
  const [massaChecklist, setMassaChecklist] = useState('');
  const [massaUren, setMassaUren] = useState(1);
  const [massaOrdnr, setMassaOrdnr] = useState('');
  const [massaStart, setMassaStart] = useState('');
  const [massaPerWeek, setMassaPerWeek] = useState(10);
  const [massaEind, setMassaEind] = useState('');
  const [massaSorteerPostcode, setMassaSorteerPostcode] = useState(true);
  const [monteurs, setMonteurs] = useState([]);
  const [massaMonteurs, setMassaMonteurs] = useState([]);
  const [massaVerdeelNacht, setMassaVerdeelNacht] = useState(false);

  useEffect(() => { loadOverzicht(); }, []);

  const loadOverzicht = async () => {
    try {
      const res = await api.get('/onderhoud/overzicht');
      const data = res.data.data || [];
      setOverzicht(data);
      const cats = [...new Set(data.map(d => d.categorie).filter(Boolean))];
      setCategorieen(cats);
      setLoading(false);
    } catch (err) {
      console.error('Fout laden overzicht:', err);
      setLoading(false);
    }
  };

  const gefilterd = selectedCat === 'alle' ? overzicht : overzicht.filter(o => o.categorie === selectedCat);

  const totaalLocaties = gefilterd.length;
  const totaalGepland = gefilterd.reduce((sum, o) => sum + (parseInt(o.aantal_werkorders) || 0), 0);
  const totaalAfgerond = gefilterd.reduce((sum, o) => sum + (parseInt(o.aantal_afgerond) || 0), 0);
  const totaalOpen = totaalGepland - totaalAfgerond;
  const voortgangPerc = totaalGepland > 0 ? Math.round((totaalAfgerond / totaalGepland) * 100) : 0;

  const statsPerFreq = {};
  gefilterd.forEach(o => {
    const f = o.frequentie || 'onbekend';
    if (!statsPerFreq[f]) statsPerFreq[f] = { totaal: 0, gepland: 0, afgerond: 0 };
    statsPerFreq[f].totaal++;
    statsPerFreq[f].gepland += parseInt(o.aantal_werkorders) || 0;
    statsPerFreq[f].afgerond += parseInt(o.aantal_afgerond) || 0;
  });

  const freqLabels = { maandelijks: 'Maandelijks', kwartaal: 'Kwartaal', halfjaarlijks: 'Halfjaarlijks', jaarlijks: 'Jaarlijks', tweejaarlijks: 'Tweejaarlijks', onbekend: 'Onbekend' };

  useEffect(() => {
    if (activeTab === "ordernummers") {
      setBulkData(gefilterd.map(o => ({ id: o.id, klant_naam: o.klant_naam, adres: o.klant_adres, type_naam: o.type_naam, ordernummer: o.ordernummer || "", frequentie: o.frequentie })));
      setSelectedIds([]);
    }
  }, [selectedCat, activeTab]);

  const openBulkEdit = () => {
    setBulkData(gefilterd.map(o => ({ id: o.id, klant_naam: o.klant_naam, adres: o.klant_adres, type_naam: o.type_naam, ordernummer: o.ordernummer || '', frequentie: o.frequentie })));
    setActiveTab('ordernummers');
  };

  const updateBulkOrdner = (id, val) => setBulkData(prev => prev.map(b => b.id === id ? { ...b, ordernummer: val } : b));

  const applyBulkOrdnr = () => {
    if (!bulkOrdnr) return;
    setBulkData(prev => prev.map(b => ({ ...b, ordernummer: bulkOrdnr })));
  };

  const saveBulkOrdners = async () => {
    setSaving(true);
    try {
      const updates = bulkData.map(b => ({ id: b.id, ordernummer: b.ordernummer }));
      await api.put('/onderhoud/bulk-ordernummers', { updates });
      alert('Ordernummers opgeslagen!');
      loadOverzicht();
    } catch (err) { alert('Fout bij opslaan'); }
    setSaving(false);
  };

  const saveBulkEnPlan = async () => {
    if (!window.confirm('Ordernummers opslaan en heel ' + planningJaar + ' inplannen voor ' + gefilterd.length + ' locaties?')) return;
    setSaving(true);
    try {
      const updates = bulkData.map(b => ({ id: b.id, ordernummer: b.ordernummer }));
      await api.put('/onderhoud/bulk-ordernummers', { updates });
      const res = await api.post('/onderhoud/jaar-inplannen', {
        categorie: selectedCat === 'alle' ? null : selectedCat,
        jaar: planningJaar
      });
      alert(res.data.message || 'Jaar ingepland!');
      loadOverzicht();
      setActiveTab('overzicht');
    } catch (err) {
      alert(err.response?.data?.message || 'Fout bij inplannen');
    }
    setSaving(false);
  };

  const toggleSelect = (id) => setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  const toggleSelectAll = () => {
    if (selectedIds.length === bulkData.length) setSelectedIds([]);
    else setSelectedIds(bulkData.map(b => b.id));
  };

  const submitBulkVerdelen = async () => {
    if (selectedIds.length === 0) return alert('Geen locaties geselecteerd');
    if (!bulkStartDatum) return alert('Kies een startdatum');
    if (!bulkPerWeek || bulkPerWeek < 1) return alert('Aantal per week moet minstens 1 zijn');
    setSaving(true);
    try {
      const res = await api.post('/onderhoud/bulk-datum-verdelen', {
        ids: selectedIds,
        startDatum: bulkStartDatum,
        perWeek: parseInt(bulkPerWeek),
        sorteerOpPostcode: bulkSorteerPostcode,
        frequentie: bulkFreq || null,
      });
      alert(res.data.message || 'Verdeeld!');
      setShowBulkModal(false);
      setSelectedIds([]);
      loadOverzicht();
    } catch (err) {
      alert(err.response?.data?.message || 'Fout bij verdelen');
    }
    setSaving(false);
  };

  // Massa-aanmaak
  const openMassaModal = async () => {
    setShowMassaModal(true);
    setMassaCat(''); setMassaSubcat('');
    setMassaKlanten([]);
    setMassaGeselecteerd([]);
    setMassaMonteurs([]);
    setMassaEind('');
    setMassaVerdeelNacht(false);
    setMassaZoek('');
    try {
      const catRes = await api.get('/onderhoud/klant-categorieen');
      setAlleCategorieen(catRes.data.categorieen || []);

      const otRes = await api.get('/onderhoud/types');
      setOnderhoudTypes(otRes.data.data || []);

      const ctRes = await api.get('/checklists/templates');
      setChecklistTemplates(ctRes.data.templates || []);

      const gebRes = await api.get('/gebruikers');
      const alleGeb = gebRes.data.gebruikers || gebRes.data.data || gebRes.data || [];
      setMonteurs(alleGeb.filter(u => u.in_planning));
    } catch (err) {
      console.error('Fout laden dropdown-data:', err);
      alert('Kon niet alle gegevens laden. Check console.');
    }
  };

  // Klanten ophalen zodra categorie gekozen is
  useEffect(() => {
    if (!massaCat) { setMassaKlanten([]); setMassaGeselecteerd([]); return; }
    setMassaLoadingKlanten(true);
    api.get(`/onderhoud/klanten-in-categorie/${encodeURIComponent(massaCat)}`)
      .then(res => {
        setMassaKlanten(res.data.klanten || []);
        setMassaGeselecteerd([]);
      })
      .catch(err => { console.error('Fout klanten:', err); setMassaKlanten([]); })
      .finally(() => setMassaLoadingKlanten(false));
  }, [massaCat]);

  // Filter klanten op "alleen zonder onderhoud" + zoekterm
  const uniqueMassaSubcats = [...new Set(massaKlanten.map(k => k.subcategorie).filter(Boolean))];
  const zichtbareKlanten = massaKlanten
    .filter(k => !massaAlleenZonder || !k.heeft_onderhoud)
    .filter(k => !massaSubcat || k.subcategorie === massaSubcat)
    .filter(k => {
      if (!massaZoek) return true;
      const q = massaZoek.toLowerCase();
      return (k.naam || '').toLowerCase().includes(q) ||
             (k.adres || '').toLowerCase().includes(q) ||
             (k.postcode || '').toLowerCase().includes(q);
    });

  const toggleMassaKlant = (id) => {
    setMassaGeselecteerd(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const massaSelecteerAlleZichtbaar = () => {
    const ids = zichtbareKlanten.map(k => k.id);
    setMassaGeselecteerd(ids);
  };

  const massaWisSelectie = () => setMassaGeselecteerd([]);

  const toggleMassaMonteur = (id) => {
    setMassaMonteurs(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const submitMassaAanmaak = async () => {
    if (!massaCat) return alert('Kies een categorie');
    if (!massaType) return alert('Kies een onderhoud-type');
    if (!massaStart) return alert('Kies een startdatum');
    if (!massaPerWeek || massaPerWeek < 1) return alert('Aantal per week moet minstens 1 zijn');
    if (massaGeselecteerd.length === 0) return alert('Selecteer minimaal 1 klant');

    if (!window.confirm(`Weet je zeker dat je voor ${massaGeselecteerd.length} klanten onderhoud wil aanmaken in categorie '${massaCat}'?`)) return;

    setSaving(true);
    try {
      if (massaEind && massaStart && new Date(massaEind) < new Date(massaStart)) {
        alert('Einddatum moet na startdatum liggen');
        setSaving(false); return;
      }
      const res = await api.post('/onderhoud/bulk-aanmaken', {
        categorie: massaCat,
        klantIds: massaGeselecteerd,
        onderhoud_type_id: parseInt(massaType),
        frequentie: massaFreq === 'aangepast' ? 'aangepast' : massaFreq, interval_aantal: massaAantal, interval_eenheid: massaEenheid,
        checklist_template_id: massaChecklist ? parseInt(massaChecklist) : null,
        verwachte_uren: parseFloat(massaUren) || 1.0,
        ordernummer: massaOrdnr || null,
        startDatum: massaStart,
        perWeek: parseInt(massaPerWeek) || 1,
        monteur_ids: massaMonteurs,
        verdeel_nachtdienst: massaVerdeelNacht,
        inhuur_templates: massaInhuurTemplates.filter(t => t && t.resource_id),
        sorteerOpPostcode: massaSorteerPostcode,
        alleenZonderOnderhoud: massaAlleenZonder,
      });
      alert(res.data.message || 'Aangemaakt!');
      setShowMassaModal(false);
      loadOverzicht();
    } catch (err) {
      alert(err.response?.data?.message || 'Fout bij aanmaken');
    }
    setSaving(false);
  };

  const btnStyle = { padding: '8px 16px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontWeight: '500', fontSize: '14px', color: '#374151' };
  const inputStyle = { width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#374151' };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Laden...</div>;

  const g = gezondheid || {};
  const problemen = [];
  if (parseInt(g.zonder_datum) > 0) problemen.push(g.zonder_datum + ' zonder volgende datum');
  if (parseInt(g.zonder_interval) > 0) problemen.push(g.zonder_interval + ' zonder interval');
  if (parseInt(g.zonder_klant) > 0) problemen.push(g.zonder_klant + ' zonder klant-koppeling');
  return (
    <div>
      {problemen.length > 0 && (
        <div style={{ margin: '0 0 12px 0', padding: '10px 14px', borderRadius: 10,
                      background: '#fffbeb', border: '1px solid #f59e0b', color: '#92400e',
                      fontSize: 13, fontWeight: 600 }}>
          ⚠️ Onderhoud-administratie: {problemen.join(' · ')} — deze regels zijn onzichtbaar in forecast en planning.
        </div>
      )}
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <h1>🔧 Onderhoud Overzicht</h1>
        <button onClick={openMassaModal} style={{ padding: '10px 18px', borderRadius: '8px', border: 'none', background: '#0ea5e9', color: 'white', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>➕ Massa-aanmaak</button>
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
        <button onClick={() => setSelectedCat('alle')} style={{ ...btnStyle, background: selectedCat === 'alle' ? '#3b82f6' : 'white', color: selectedCat === 'alle' ? 'white' : '#374151', border: selectedCat === 'alle' ? 'none' : '1px solid #d1d5db' }}>Alle</button>
        {categorieen.map(cat => (
          <button key={cat} onClick={() => setSelectedCat(cat)} style={{ ...btnStyle, background: selectedCat === cat ? '#3b82f6' : 'white', color: selectedCat === cat ? 'white' : '#374151', border: selectedCat === cat ? 'none' : '1px solid #d1d5db' }}>{cat}</button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '0', marginBottom: '0', borderBottom: '2px solid #e5e7eb' }}>
        <button onClick={() => setActiveTab('overzicht')} style={{ padding: '12px 24px', border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: '600', background: 'none', color: activeTab === 'overzicht' ? '#3b82f6' : '#6b7280', borderBottom: activeTab === 'overzicht' ? '2px solid #3b82f6' : '2px solid transparent', marginBottom: '-2px' }}>📊 Voortgang</button>
        <button onClick={() => openBulkEdit()} style={{ padding: '12px 24px', border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: '600', background: 'none', color: activeTab === 'ordernummers' ? '#3b82f6' : '#6b7280', borderBottom: activeTab === 'ordernummers' ? '2px solid #3b82f6' : '2px solid transparent', marginBottom: '-2px' }}>📝 Ordernummers &amp; Inplannen</button>
      </div>

      {activeTab === 'overzicht' && (
        <div style={{ background: 'white', borderRadius: '0 0 8px 8px', padding: '20px', border: '1px solid #e5e7eb', borderTop: 'none' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px', marginBottom: '24px' }}>
            <div style={{ background: '#f0f9ff', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: '#1e40af' }}>{totaalLocaties}</div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>Locaties</div>
            </div>
            <div style={{ background: '#f0fdf4', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: '#166534' }}>{totaalGepland}</div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>Werkorders</div>
            </div>
            <div style={{ background: '#ecfdf5', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: '#10b981' }}>{totaalAfgerond}</div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>Afgerond</div>
            </div>
            <div style={{ background: '#fffbeb', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: '#f59e0b' }}>{totaalOpen}</div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>Nog te doen</div>
            </div>
            <div style={{ background: '#f9fafb', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
              <div style={{ fontSize: '28px', fontWeight: '700', color: voortgangPerc >= 80 ? '#10b981' : voortgangPerc >= 50 ? '#f59e0b' : '#dc2626' }}>{voortgangPerc}%</div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>Voortgang</div>
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>Totale voortgang</span>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>{totaalAfgerond} / {totaalGepland}</span>
            </div>
            <div style={{ height: '12px', background: '#e5e7eb', borderRadius: '6px', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: voortgangPerc + '%', background: voortgangPerc >= 80 ? '#10b981' : voortgangPerc >= 50 ? '#f59e0b' : '#3b82f6', borderRadius: '6px', transition: 'width 0.5s' }} />
            </div>
          </div>

          <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Per frequentie</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '24px' }}>
            {Object.entries(statsPerFreq).map(([freq, stats]) => {
              const perc = stats.gepland > 0 ? Math.round((stats.afgerond / stats.gepland) * 100) : 0;
              return (
                <div key={freq} style={{ background: '#f9fafb', borderRadius: '8px', padding: '16px', border: '1px solid #e5e7eb' }}>
                  <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '8px' }}>{freqLabels[freq] || freq}</div>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '4px' }}>{stats.totaal} locaties - {stats.afgerond}/{stats.gepland} werkorders</div>
                  <div style={{ height: '8px', background: '#e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: perc + '%', background: perc >= 80 ? '#10b981' : perc >= 50 ? '#f59e0b' : '#3b82f6', borderRadius: '4px' }} />
                  </div>
                  <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px', textAlign: 'right' }}>{perc}%</div>
                </div>
              );
            })}
          </div>

          <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>Locaties ({gefilterd.length})</h3>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e5e7eb', textAlign: 'left' }}>
                  <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Locatie</th>
                  <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Type</th>
                  <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Ordernr</th>
                  <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Freq.</th>
                  <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Volgende</th>
                  <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Voortgang</th>
                </tr>
              </thead>
              <tbody>
                {gefilterd.map(o => {
                  const gepland = parseInt(o.aantal_werkorders) || 0;
                  const afgerond = parseInt(o.aantal_afgerond) || 0;
                  const perc = gepland > 0 ? Math.round((afgerond / gepland) * 100) : 0;
                  const verlopen = o.volgende_datum && new Date(o.volgende_datum) < new Date();
                  return (
                    <tr key={o.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td style={{ padding: '10px 8px' }}>
                        <div style={{ fontWeight: '500', color: '#111827' }}>{o.klant_naam}</div>
                        <div style={{ fontSize: '12px', color: '#9ca3af' }}>{o.klant_adres}</div>
                      </td>
                      <td style={{ padding: '10px 8px' }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                          <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: o.type_kleur || '#3b82f6' }} />
                          {o.type_naam}
                        </span>
                      </td>
                      <td style={{ padding: '10px 8px', fontFamily: 'monospace', fontWeight: '500' }}>{o.ordernummer || '-'}</td>
                      <td style={{ padding: '10px 8px', fontSize: '13px' }}>{freqLabels[o.frequentie] || o.frequentie}</td>
                      <td style={{ padding: '10px 8px', color: verlopen ? '#dc2626' : '#111827', fontWeight: verlopen ? '600' : '400' }}>
                        {o.volgende_datum ? new Date(o.volgende_datum).toLocaleDateString('nl-NL') : '-'}
                        {verlopen && ' ⚠️'}
                      </td>
                      <td style={{ padding: '10px 8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ flex: 1, height: '8px', background: '#e5e7eb', borderRadius: '4px', overflow: 'hidden', minWidth: '60px' }}>
                            <div style={{ height: '100%', width: perc + '%', background: perc >= 80 ? '#10b981' : perc >= 50 ? '#f59e0b' : '#3b82f6', borderRadius: '4px' }} />
                          </div>
                          <span style={{ fontSize: '12px', color: '#6b7280', whiteSpace: 'nowrap' }}>{afgerond}/{gepland}</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {gefilterd.length === 0 && (
            <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
              <p style={{ fontSize: '40px', margin: '0 0 12px' }}>🔧</p>
              <p>Geen onderhoud gevonden voor deze categorie</p>
              <p style={{ fontSize: '13px', marginTop: '8px' }}>Gebruik <strong>➕ Massa-aanmaak</strong> om voor een hele categorie klanten onderhoud aan te maken</p>
            </div>
          )}
        </div>
      )}

      {activeTab === 'ordernummers' && (
        <div style={{ background: 'white', borderRadius: '0 0 8px 8px', padding: '20px', border: '1px solid #e5e7eb', borderTop: 'none' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
            <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0 }}>📝 Ordernummers {selectedCat !== 'alle' ? '- ' + selectedCat : ''} ({bulkData.length} locaties)</h3>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <label style={{ fontSize: '13px', color: '#6b7280' }}>Jaar:</label>
              <select value={planningJaar} onChange={e => setPlanningJaar(parseInt(e.target.value))} style={{ padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' }}>
                <option value={2026}>2026</option>
                <option value={2027}>2027</option>
                <option value={2028}>2028</option>
              </select>
            </div>
          </div>

          {bulkData.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>Geen onderhoud in deze categorie</p>
          ) : (
            <>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '16px', padding: '12px', background: '#f0f9ff', borderRadius: '8px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Ordernummer voor alle:</span>
                <input type="text" placeholder="123456" maxLength="10" value={bulkOrdnr} onChange={e => setBulkOrdnr(e.target.value)} style={{ padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', fontFamily: 'monospace', width: '120px' }} />
                <button onClick={applyBulkOrdnr} style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', background: '#3b82f6', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>Toepassen op alle</button>
              </div>

              {selectedIds.length > 0 && (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '16px', padding: '12px', background: '#f5f3ff', borderRadius: '8px', border: '1px solid #ddd6fe' }}>
                  <span style={{ fontSize: '14px', fontWeight: '500', color: '#6d28d9' }}>✅ {selectedIds.length} locatie(s) geselecteerd</span>
                  <button onClick={() => setSelectedIds([])} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #ddd6fe', background: 'white', color: '#6d28d9', cursor: 'pointer', fontSize: '12px' }}>Wis selectie</button>
                </div>
              )}

              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #e5e7eb', textAlign: 'left' }}>
                      <th style={{ padding: '10px 8px', width: '40px' }}>
                        <input type="checkbox" checked={selectedIds.length === bulkData.length && bulkData.length > 0} onChange={toggleSelectAll} title="Alles selecteren" />
                      </th>
                      <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Locatie</th>
                      <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Type</th>
                      <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500' }}>Freq.</th>
                      <th style={{ padding: '10px 8px', color: '#6b7280', fontWeight: '500', width: '150px' }}>Ordernummer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bulkData.map(item => (
                      <tr key={item.id} style={{ borderBottom: '1px solid #f3f4f6', background: selectedIds.includes(item.id) ? '#f5f3ff' : 'transparent' }}>
                        <td style={{ padding: '10px 8px' }}>
                          <input type="checkbox" checked={selectedIds.includes(item.id)} onChange={() => toggleSelect(item.id)} />
                        </td>
                        <td style={{ padding: '10px 8px' }}>
                          <div style={{ fontWeight: '500', color: '#111827' }}>{item.klant_naam}</div>
                          <div style={{ fontSize: '12px', color: '#9ca3af' }}>{item.adres}</div>
                        </td>
                        <td style={{ padding: '10px 8px' }}>{item.type_naam}</td>
                        <td style={{ padding: '10px 8px', fontSize: '13px' }}>{freqLabels[item.frequentie] || item.frequentie}</td>
                        <td style={{ padding: '10px 8px' }}>
                          <input type="text" value={item.ordernummer} onChange={e => updateBulkOrdner(item.id, e.target.value)} placeholder="123456" maxLength="10" style={{ width: '100%', padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', fontFamily: 'monospace' }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', paddingTop: '20px', borderTop: '1px solid #e5e7eb', marginTop: '20px', flexWrap: 'wrap' }}>
                <button onClick={() => setShowBulkModal(true)} disabled={selectedIds.length === 0} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: selectedIds.length === 0 ? '#d1d5db' : '#8b5cf6', color: 'white', cursor: selectedIds.length === 0 ? 'not-allowed' : 'pointer', fontWeight: '500', fontSize: '14px' }}>🔀 Bulk Verdelen ({selectedIds.length})</button>
                <button onClick={saveBulkOrdners} disabled={saving} style={btnStyle}>{saving ? '⏳...' : '💾 Alleen Opslaan'}</button>
                <button onClick={saveBulkEnPlan} disabled={saving} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#10b981', color: 'white', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}>{saving ? '⏳ Bezig...' : '📅 Opslaan + ' + planningJaar + ' Inplannen'}</button>
              </div>
            </>
          )}
        </div>
      )}

      {showBulkModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '480px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600' }}>🔀 Bulk Verdelen</h3>
            <p style={{ color: '#6b7280', fontSize: '14px', marginTop: 0, marginBottom: '20px' }}>{selectedIds.length} locaties gelijkmatig verdelen over werkdagen vanaf de startdatum.</p>
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Startdatum</label>
              <input type="date" value={bulkStartDatum} onChange={e => setBulkStartDatum(e.target.value)} style={inputStyle} />
              <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>Wordt automatisch naar eerstvolgende maandag geschoven indien nodig</div>
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Aantal per week</label>
              <input type="number" min="1" max="50" value={bulkPerWeek} onChange={e => setBulkPerWeek(e.target.value)} style={inputStyle} />
              {selectedIds.length > 0 && bulkPerWeek > 0 && (<div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>≈ {Math.ceil(selectedIds.length / bulkPerWeek)} weken werk</div>)}
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={labelStyle}>Frequentie instellen (optioneel)</label>
              <select value={bulkFreq} onChange={e => setBulkFreq(e.target.value)} style={inputStyle}>
                <option value="">— niet wijzigen —</option>
                <option value="jaarlijks">Jaarlijks</option>
                <option value="tweejaarlijks">Tweejaarlijks</option>
              </select>
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontSize: '14px', cursor: 'pointer', color: '#374151' }}>
              <input type="checkbox" checked={bulkSorteerPostcode} onChange={e => setBulkSorteerPostcode(e.target.checked)} />
              Sorteren op postcode (zelfde wijk = zelfde week)
            </label>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowBulkModal(false)} disabled={saving} style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontSize: '14px', color: '#374151' }}>Annuleer</button>
              <button onClick={submitBulkVerdelen} disabled={saving} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#8b5cf6', color: 'white', cursor: saving ? 'wait' : 'pointer', fontSize: '14px', fontWeight: '500' }}>{saving ? '⏳ Bezig...' : '✅ Verdelen'}</button>
            </div>
          </div>
        </div>
      )}

      {showMassaModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px', overflowY: 'auto' }}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '720px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)', maxHeight: '95vh', display: 'flex', flexDirection: 'column' }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '18px', fontWeight: '600' }}>➕ Massa-aanmaak onderhoud</h3>
            <p style={{ color: '#6b7280', fontSize: '14px', marginTop: 0, marginBottom: '16px' }}>Kies een categorie, selecteer de klanten, en maak in één keer onderhoud aan.</p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={labelStyle}>Categorie *</label>
                <select value={massaCat} onChange={e => { setMassaCat(e.target.value); setMassaSubcat(''); }} style={inputStyle}>
                  <option value="">— kies —</option>
                  {alleCategorieen.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Filter</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', cursor: 'pointer', background: massaAlleenZonder ? '#f0fdf4' : 'white' }}>
                  <input type="checkbox" checked={massaAlleenZonder} onChange={e => setMassaAlleenZonder(e.target.checked)} />
                  Alleen klanten zonder onderhoud
                </label>
              </div>
            </div>

            {massaCat && uniqueMassaSubcats.length > 0 && (
              <div style={{ marginBottom: '12px' }}>
                <label style={labelStyle}>Subcategorie</label>
                <select value={massaSubcat} onChange={e => setMassaSubcat(e.target.value)} style={inputStyle}>
                  <option value="">— alle subcategorieën —</option>
                  {uniqueMassaSubcats.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            )}
            {/* KLANTENLIJST */}
            {massaCat && (
              <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '16px', background: '#f9fafb' }}>
                <div style={{ padding: '10px 12px', borderBottom: '1px solid #e5e7eb', display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <strong style={{ fontSize: '13px' }}>{zichtbareKlanten.length}</strong>
                  <span style={{ fontSize: '13px', color: '#6b7280' }}>klanten zichtbaar</span>
                  <span style={{ flex: 1 }} />
                  <span style={{ fontSize: '13px', color: '#0369a1', fontWeight: '500' }}>✅ {massaGeselecteerd.length} geselecteerd</span>
                  <button onClick={massaSelecteerAlleZichtbaar} disabled={zichtbareKlanten.length === 0} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #bae6fd', background: 'white', color: '#0369a1', cursor: 'pointer', fontSize: '12px' }}>Selecteer alle zichtbaar</button>
                  <button onClick={massaWisSelectie} disabled={massaGeselecteerd.length === 0} style={{ padding: '4px 10px', borderRadius: '6px', border: '1px solid #d1d5db', background: 'white', color: '#374151', cursor: 'pointer', fontSize: '12px' }}>Wis selectie</button>
                </div>
                <div style={{ padding: '10px 12px', borderBottom: '1px solid #e5e7eb' }}>
                  <input type="text" placeholder="🔍 Zoek op naam, adres of postcode..." value={massaZoek} onChange={e => setMassaZoek(e.target.value)} style={{ ...inputStyle, fontSize: '13px' }} />
                </div>
                <div style={{ maxHeight: '280px', overflowY: 'auto', background: 'white' }}>
                  {massaLoadingKlanten ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>{(terms?.klant_plural || "Klanten")} laden...</div>
                  ) : zichtbareKlanten.length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#9ca3af', fontSize: '13px' }}>Geen klanten zichtbaar</div>
                  ) : (
                    zichtbareKlanten.map(k => {
                      const gekozen = massaGeselecteerd.includes(k.id);
                      return (
                        <label key={k.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', background: gekozen ? '#eff6ff' : 'transparent' }}>
                          <input type="checkbox" checked={gekozen} onChange={() => toggleMassaKlant(k.id)} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: '13px', fontWeight: '500', color: '#111827' }}>{k.naam}</div>
                            <div style={{ fontSize: '12px', color: '#9ca3af' }}>
                              {k.postcode ? <span style={{ fontFamily: 'monospace', marginRight: '6px' }}>{k.postcode}</span> : null}
                              {k.adres}
                            </div>
                          </div>
                          {k.heeft_onderhoud && <span style={{ fontSize: '11px', background: '#fef3c7', color: '#92400e', padding: '2px 6px', borderRadius: '4px' }}>Heeft al onderhoud</span>}
                        </label>
                      );
                    })
                  )}
                </div>
              </div>
            )}

            {/* FORMULIER */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={labelStyle}>Onderhoud-type *</label>
                <select value={massaType} onChange={e => setMassaType(e.target.value)} style={inputStyle}>
                  <option value="">— kies —</option>
                  {onderhoudTypes.map(t => <option key={t.id} value={t.id}>{t.naam}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Frequentie *</label>
                <select value={massaFreq} onChange={e => {
                  const v = e.target.value;
                  setMassaFreq(v);
                  if (v === 'jaarlijks')           { setMassaAantal(1); setMassaEenheid('jaar'); }
                  else if (v === 'tweejaarlijks') { setMassaAantal(2); setMassaEenheid('jaar'); }
                  else if (v === 'halfjaarlijks') { setMassaAantal(6); setMassaEenheid('maand'); }
                  else if (v === 'kwartaal')      { setMassaAantal(3); setMassaEenheid('maand'); }
                  else if (v === 'maandelijks')   { setMassaAantal(1); setMassaEenheid('maand'); }
                }} style={inputStyle}>
                  <option value="jaarlijks">Jaarlijks</option>
                  <option value="tweejaarlijks">Tweejaarlijks</option>
                  <option value="halfjaarlijks">Halfjaarlijks</option>
                  <option value="kwartaal">Kwartaal</option>
                  <option value="maandelijks">Maandelijks</option>
                  <option value="aangepast">Aangepast…</option>
                </select>
                {massaFreq === 'aangepast' && (
                  <div style={{ display: 'flex', gap: '8px', marginTop: '6px' }}>
                    <input type="number" min="1" max="99" value={massaAantal} onChange={e => setMassaAantal(parseInt(e.target.value) || 1)} style={{...inputStyle, width: '80px'}} placeholder="3"/>
                    <select value={massaEenheid} onChange={e => setMassaEenheid(e.target.value)} style={inputStyle}>
                      <option value="dag">dag(en)</option>
                      <option value="week">week/weken</option>
                      <option value="maand">maand(en)</option>
                      <option value="jaar">jaar/jaren</option>
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '12px' }}>
              <label style={labelStyle}>Checklist template (optioneel)</label>
              <select value={massaChecklist} onChange={e => setMassaChecklist(e.target.value)} style={inputStyle}>
                <option value="">— geen —</option>
                {checklistTemplates.map(t => <option key={t.id} value={t.id}>{t.naam || t.titel}</option>)}
              </select>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={labelStyle}>Verwachte uren</label>
                <input type="number" step="0.25" min="0.25" value={massaUren} onChange={e => setMassaUren(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Ordernummer (optioneel)</label>
                <input type="text" value={massaOrdnr} onChange={e => setMassaOrdnr(e.target.value)} maxLength="10" placeholder="123456" style={{ ...inputStyle, fontFamily: 'monospace' }} />
              </div>
            </div>

            {/* NACHTDIENST-VERDELING */}
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', border: '1px solid ' + (massaVerdeelNacht ? '#7c3aed' : '#d1d5db'), borderRadius: '6px', marginBottom: '12px', cursor: 'pointer', background: massaVerdeelNacht ? '#ede9fe' : 'white' }}>
              <input type="checkbox" checked={massaVerdeelNacht} onChange={e => setMassaVerdeelNacht(e.target.checked)} />
              <div>
                <div style={{ fontSize: '13px', fontWeight: 500 }}>🌙 Verdeel over nachtdienst-monteurs (auto per week)</div>
                <div style={{ fontSize: '11px', color: '#6b7280' }}>Backend kijkt per geplande week wie nachtdienst heeft en wijst die toe. Handmatige monteur-selectie hieronder wordt dan genegeerd.</div>
              </div>
            </label>

            {/* MONTEUR-SELECTIE */}
            <div style={{ marginBottom: '12px', opacity: massaVerdeelNacht ? 0.4 : 1, pointerEvents: massaVerdeelNacht ? 'none' : 'auto' }}>
              <label style={labelStyle}>Monteur(s) toewijzen (optioneel)</label>
              {monteurs.length === 0 ? (
                <div style={{ fontSize: '13px', color: '#9ca3af', padding: '8px 10px', border: '1px dashed #d1d5db', borderRadius: '6px' }}>Geen monteurs gevonden</div>
              ) : (
                <div style={{ border: '1px solid #d1d5db', borderRadius: '6px', maxHeight: '140px', overflowY: 'auto', background: 'white' }}>
                  {monteurs.map(m => {
                    const gekozen = massaMonteurs.includes(m.id);
                    return (
                      <label key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', cursor: 'pointer', background: gekozen ? '#eff6ff' : 'transparent', fontSize: '13px', borderBottom: '1px solid #f3f4f6' }}>
                        <input type="checkbox" checked={gekozen} onChange={() => toggleMassaMonteur(m.id)} />
                        <span>{m.naam || m.gebruikersnaam}</span>
                      </label>
                    );
                  })}
                </div>
              )}
              <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                {massaMonteurs.length === 0 ? 'Geen monteur gekozen — werkorders komen wel in de planning maar zonder toewijzing' : `${massaMonteurs.length} monteur(s) geselecteerd`}
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={labelStyle}>Startdatum *</label>
                <input type="date" value={massaStart} onChange={e => setMassaStart(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Einddatum (optioneel)</label>
                <input type="date" value={massaEind} min={massaStart || undefined} onChange={e => setMassaEind(e.target.value)} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Aantal per week *</label>
                <input type="number" min="1" max="100" value={massaPerWeek} onChange={e => setMassaPerWeek(e.target.value)} style={inputStyle} />
              </div>
            </div>

            {massaGeselecteerd.length > 0 && massaPerWeek > 0 && (
              <div style={{ fontSize: '12px', color: '#0369a1', marginBottom: '12px', padding: '8px 12px', background: '#f0f9ff', borderRadius: '6px' }}>
                📅 {massaGeselecteerd.length} klanten ÷ {massaPerWeek} per week = ≈ {Math.ceil(massaGeselecteerd.length / massaPerWeek)} weken werk
              </div>
            )}

            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', fontSize: '14px', cursor: 'pointer', color: '#374151' }}>
              <input type="checkbox" checked={massaSorteerPostcode} onChange={e => setMassaSorteerPostcode(e.target.checked)} />
              Verdelen op postcode-volgorde (zelfde wijk = zelfde week)
            </label>

            {/* === Inhuur per werkorder === */}
            <div style={{ marginBottom: '16px', padding: '12px', background: '#fafafa', border: '1px solid #e5e7eb', borderRadius: '8px' }}>
              <label style={{...labelStyle, marginBottom: '8px', display: 'block'}}>🤝 Inhuur per werkorder (optioneel)</label>
              {massaInhuurTemplates.map((t, idx) => (
                <div key={idx} style={{ display: 'flex', gap: '6px', marginTop: '6px', alignItems: 'center' }}>
                  <select value={t.resource_id || ''} onChange={e => { const v=[...massaInhuurTemplates]; v[idx]={...v[idx], resource_id: parseInt(e.target.value)||null}; setMassaInhuurTemplates(v); }} style={{...inputStyle, flex: 2}}>
                    <option value="">— kies resource —</option>
                    {inhuurResources.map(r => (<option key={r.id} value={r.id}>{r.naam} ({r.type})</option>))}
                  </select>
                  <input type="number" min="1" value={t.aantal || 1} onChange={e => { const v=[...massaInhuurTemplates]; v[idx]={...v[idx], aantal: parseInt(e.target.value)||1}; setMassaInhuurTemplates(v); }} style={{...inputStyle, width: '60px'}} title="Aantal"/>
                  <input type="number" value={t.offset_dagen_start || 0} onChange={e => { const v=[...massaInhuurTemplates]; v[idx]={...v[idx], offset_dagen_start: parseInt(e.target.value)||0}; setMassaInhuurTemplates(v); }} style={{...inputStyle, width: '60px'}} title="Offset dagen vóór werkorder (0 = zelfde dag)"/>
                  <input type="number" value={t.offset_dagen_eind || 0} onChange={e => { const v=[...massaInhuurTemplates]; v[idx]={...v[idx], offset_dagen_eind: parseInt(e.target.value)||0}; setMassaInhuurTemplates(v); }} style={{...inputStyle, width: '60px'}} title="Offset dagen ná werkorder"/>
                  <button type="button" onClick={() => setMassaInhuurTemplates(massaInhuurTemplates.filter((_,i) => i !== idx))} style={{padding: '6px 10px', borderRadius: '6px', border: 'none', background: '#ef4444', color: 'white', cursor: 'pointer'}}>✕</button>
                </div>
              ))}
              <button type="button" onClick={() => setMassaInhuurTemplates([...massaInhuurTemplates, {resource_id: null, aantal: 1, offset_dagen_start: 0, offset_dagen_eind: 0}])} style={{marginTop: '8px', padding: '6px 12px', borderRadius: '6px', border: '1px dashed #94a3b8', background: 'white', cursor: 'pointer', fontSize: '13px'}}>+ Resource toevoegen</button>
              {massaInhuurTemplates.length > 0 && (<div style={{fontSize: '11px', color: '#6b7280', marginTop: '6px'}}>Per werkorder uit dit onderhoud wordt automatisch een inhuur-aanvraag aangemaakt. Offset in dagen vóór/ná werkorder-datum (0 = zelfde dag).</div>)}
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
              <button onClick={() => setShowMassaModal(false)} disabled={saving} style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #d1d5db', background: 'white', cursor: 'pointer', fontSize: '14px', color: '#374151' }}>Annuleer</button>
              <button onClick={submitMassaAanmaak} disabled={saving || massaGeselecteerd.length === 0} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: (saving || massaGeselecteerd.length === 0) ? '#d1d5db' : '#0ea5e9', color: 'white', cursor: (saving || massaGeselecteerd.length === 0) ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: '500' }}>{saving ? '⏳ Bezig...' : `✅ Aanmaken voor ${massaGeselecteerd.length} klant(en)`}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnderhoudOverzicht;
